<template>
    <div>
        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-sign-in-alt mr-1"></i> Ingressar com Código
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                    </div>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div class="container">
            <div class="row">
                <div class="col-sm-5 mx-auto">
                    <b-overlay :show="loading" rounded="sm">
                        <b-card title="">
                            <b-form @submit="submit" @submit.stop.prevent>

                                <!-- Field -->
                                <b-form-group
                                    label="Código"
                                    description="O código da turma é fornecido pelo administrador da conta principal, peça a ele o código para ingressar na turma.">
                                    <!-- Input -->
                                    <b-form-input
                                        v-model="form.code"
                                        :state="hasErrors('code', errors)"
                                    ></b-form-input>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="code" />
                                </b-form-group>

                                <!-- Submit -->
                                <b-button type="submit" variant="primary" :disable="loading">
                                    Entrar na Turma
                                </b-button>

                            </b-form>
                        </b-card>
                    </b-overlay>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['endpoint'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                code: null
            }
        }
    },
    methods: {

        submit() {
            this.loading = true;
            axios.post(this.endpoint, this.form)
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
